(function() {
    'use strict';

    angular
        .module('expedientesUriarteApp')
        .component('newTask', {
            bindings: {
                newTask: '<',
                entitytype: '<',
                entityid: '<',
                onNew: '<',
                cancel: '&',
                save: '&'
            },
            templateUrl: 'app/entities/task/new-task-component.html',
            controller: ['$timeout',
                function($timeout) {
                    var $ctrl = this;

                    $ctrl.onCancel = onCancel;
                    $ctrl.onSave = onSave;
                    $ctrl.initNew = initNew;

                    $timeout(function() {
                        angular.element('#description').focus();
                    });

                    function initNew() {
                        $ctrl.onNew = true;
                        $ctrl.newTask.entityType = $ctrl.entitytype;
                        $ctrl.newTask.entityId = $ctrl.entityid;
                        $ctrl.newTask.type = "TASK";
                        $ctrl.newTask.reminderDate = null;
                        $ctrl.newTask.done = false;
                    }

                    function onCancel() {
                        $ctrl.onNew = false;
                        $ctrl.cancel();
                    }

                    function onSave() {
                        $ctrl.onNew = false;
                        $ctrl.save();
                    }
                }
            ]
        });
})();
